import { jsx as _jsx } from "react/jsx-runtime";
import SubHeader from '../SubHeader';
import { Routes } from '../../../../constants/routes';
import { useTranslation } from 'react-i18next';
const StablesSubHeader = () => {
    const { t } = useTranslation();
    const navBarProfiles = [
        {
            name: t('race_stable'),
            link: Routes.STABLES,
            disabled: false,
            parent: 'race'
        },
        {
            name: t('breeding_stable'),
            link: Routes.BREEDING,
            disabled: true,
            parent: 'breeding'
        }
    ];
    return _jsx(SubHeader, { data: navBarProfiles });
};
export default StablesSubHeader;
